import i18n from "@/i18n/index.ts";
export default class DataStores {
}
DataStores.Breadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/",
        text: i18n.t("breadcrumbs.cms"),
    },
    {
        to: "/faq",
        text: "Stores List",
        disabled: true,
    },
];
DataStores.TableHeaders = [
    {
        text: "Store name",
        value: "store_name",
        width: "25%",
    },
    {
        text: "Address",
        value: "address",
        width: "22%",
    },
    {
        text: "Origin",
        value: "origine",
        sortable: false,
        width: "8%",
    },
    {
        text: "POS code",
        value: "pos_code",
        width: "12%",
    },
    {
        text: "Create At",
        value: "created_at",
        width: "18%",
    },
    {
        text: "Visible",
        value: "is_hidden",
        width: "8%",
    },
    {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "7%",
    },
];
